import styled from "styled-components";
import Navbar from "../../components/Navbar";
import Announcement from "../../components/Announcement";
import Footer from "../../components/Footer";
import ItemAnnouncement from "../../components/ItemAnnoucement";
import { mobile } from "../../responsive";


const Container = styled.div``;

const Wrapper = styled.div`
  padding: 50px;
  display: flex;
  ${mobile({ display: "grid" })}
`;

const ImgContainer = styled.div`
  flex: 1;
  border: 3px solid;
  border-color: #0039a6;
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
`;

const InfoContainer = styled.div`
  flex: 1;
  padding: 0px 50px;
`;

const Title = styled.h1`
  font-weight: 200;
  text-align: center;
`;

const Desc = styled.p`
  margin: 20px 0px;
  font-size: 20px;
`;

const Price = styled.span`
  font-weight: 100;
  font-size: 40px;
`;



const AugerBits = () => {
  return (
    <Container>
      <Navbar/>
      <Announcement/>
      <Wrapper>
        <ImgContainer>
          <Image src="../images/augerbits.JPG" />
        </ImgContainer>
        <InfoContainer>
          <Title>Auger Bits</Title>
          <ItemAnnouncement/>
          <Desc>
            Delivery is not offered.
          </Desc>
          <Price></Price>
        </InfoContainer>
      </Wrapper>
      <Footer />
    </Container>
  );
};

export default AugerBits;